// src/hooks/useStickyNavbar.js
import { useState, useEffect } from 'react';

export const useStickyNavbar = (scrollThreshold = 150) => {
    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.innerWidth >= 992) {
                setIsSticky(window.scrollY > scrollThreshold);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll); // Handle window resize

        // Initial check
        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, [scrollThreshold]);

    return isSticky;
};